<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb"></Breadcrumb>
    <h5 class="title is-5">{{ $t("profile.title") }}</h5>
    <FlashMessage color="is-info"></FlashMessage>
    <div class="buttons">
      <div class="field has-addons">
        <p class="control">
          <router-link
            :to="{ name: 'profileEdit' }"
            class="button has-tooltip-arrow"
            :data-tooltip="$t('profile.edit')"
          >
            <span class="icon is-small">
              <i class="fas fa-edit"></i>
            </span>
            <span>{{ $t("Edit") }}</span>
          </router-link>
        </p>
        <p class="control" v-if="mfa == false">
          <router-link
            :to="{ name: 'profileStartMfa' }"
            class="button has-tooltip-arrow"
          >
            <span class="icon is-small">
              <i class="fas fa-cog"></i>
            </span>
            <span>{{ $t("auth.startMfa") }}</span>
          </router-link>
        </p>
        <p class="control" v-if="mfa">
          <router-link
            :to="{ name: 'profileStopMfa' }"
            class="button has-tooltip-arrow"
          >
            <span class="icon is-small">
              <i class="fas fa-cog"></i>
            </span>
            <span>{{ $t("auth.stopMfa") }}</span>
          </router-link>
        </p>
        <p class="control">
          <router-link
            :to="{ name: 'authForgotPassword' }"
            class="button has-tooltip-arrow"
          >
            <span class="icon is-small">
              <i class="fas fa-lock"></i>
            </span>
            <span>{{ $t("profile.passwordReset") }}</span>
          </router-link>
        </p>
      </div>
      <router-link :to="{ name: dynamicHelpRoute }" target="_blank">
        <span class="icon is-small">
          <i class="fa fa-question-circle"></i>
        </span>
        <span>{{ $t("profile.helpSettingMFA") }}</span>
      </router-link>
    </div>
    <div>
      <vue-element-loading :active="isLoading" spinner="spinner" />
      <table v-if="!isLoading" class="table is-fullwidth">
        <thead></thead>
        <tbody>
          <tr>
            <th width="20%">{{ $t("Email") }}</th>
            <td>{{ user.userId }}</td>
          </tr>
          <tr>
            <th>{{ $t("Name") }}</th>
            <td>{{ user.userName }}</td>
          </tr>
          <tr>
            <th>{{ $t("profile.lang") }}</th>
            <td>
              {{ $t(user.lang) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t("profile.userRole") }}</th>
            <td>
              <span v-if="user.userRole == 'admin'">
                {{ $t("profile.admin") }}
              </span>
              <span v-else>
                {{ $t("profile.user") }}
              </span>
            </td>
          </tr>
          <tr>
            <th>{{ $t("profile.alert1") }}</th>
            <td>
              <span v-if="user.alert1 == 't'">{{
                $t("profile.alert1t") + " - " + $t("profile.alert1tMessage")
              }}</span>
              <span v-else>{{
                $t("profile.alert1f") + " - " + $t("profile.alert1fMessage")
              }}</span>
            </td>
          </tr>
          <tr>
            <th>{{ $t("profile.alert2") }}</th>
            <td>
              <span
                v-if="user.alert2 == 't' && user.alert2_only_with_events == 'f'"
                >{{
                  $t("profile.alert2t") +
                    " - " +
                    $t("profile.alert2DailyMessage")
                }}</span
              >
              <span
                v-else-if="
                  user.alert2 == 't' && user.alert2_only_with_events == 't'
                "
                >{{
                  $t("profile.alert2t") +
                    " - " +
                    $t("profile.alert2OnlyWithEventsMessage")
                }}</span
              >
              <span v-else>{{
                $t("profile.alert2f") + " - " + $t("profile.alert2Message")
              }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import { ImsrUsers } from "@/lib/imsrUsers.js";
import { computed, ref } from "@vue/reactivity";
import VueElementLoading from "vue-element-loading";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  components: {
    Breadcrumb,
    FlashMessage,
    VueElementLoading,
  },
  setup() {
    const { locale } = useI18n();
    const store = useStore();
    const router = useRouter();
    const user = ref({});
    const breadcrumb = ref([
      { title: "Home", path: "/" },
      { title: "Profile", path: "#", isActive: true },
    ]);
    const isLoading = ref(false);
    const mfa = ref(false);

    const getUser = async () => {
      try {
        isLoading.value = true;
        const imsrUsers = new ImsrUsers();
        user.value = await imsrUsers.getUser(store.getters.tenantId);
        const checkmfa = await imsrUsers.checkMfa(store.getters.tenantId);
        mfa.value = checkmfa.mfa;
        isLoading.value = false;
      } catch (e) {
        router.push({ name: "InternalServerError" });
      }
    };
    getUser();

    return {
      user,
      mfa,
      breadcrumb,
      isLoading,
      dynamicHelpRoute: computed(() => {
        return locale.value === "ja" ? "helpMfaja" : "helpMfaen";
      }),
    };
  },
};
</script>
